enum TeamParticipationRole {
    MEMBER = 'member',
    MANAGER = 'manager',
    LEAD = 'lead',
}

export default TeamParticipationRole;
